export default "__VITE_ASSET__mxXJ6CII__"